import { handleError, handleSuccess, triggerDelete, triggerGet, triggerPost, triggerPut } from './utils';

// Create Group
const createGroupApiRequest = async data => {
  const apiResponse = await triggerPost('/business/prodgroups/', data);
  const responseData = await apiResponse.json();
  if (responseData.report.status === 201) {
    return handleSuccess(responseData);
  }
  return handleError(responseData);
};

// Edit Group
const editProductGroupApiRequest = async (id, data) => {
  const apiResponse = await triggerPut("/business/prodgroups/".concat(id, "/"), data);
  const responseData = await apiResponse.json();
  if (responseData.report.status === 200) {
    return handleSuccess(responseData);
  }
  return handleError(responseData);
};

// Delete Group
const deleteProductGroupApiRequest = async id => {
  const apiResponse = await triggerDelete("/business/prodgroups/".concat(id, "/"));
  if (apiResponse.status === 204) {
    return {
      success: true,
      data: {},
      report: {}
    };
  }
  return {
    success: false
  };
};

// Return All groups for products
const getGroupsForProductsApiRequest = async () => {
  const apiResponse = await triggerGet('/business/prodgroups/');
  const responseData = await apiResponse.json();
  if (responseData.report.status === 200) {
    return handleSuccess(responseData);
  }
  return handleError(responseData);
};

// Return all the products ACITVE
const getAllProductsApiRequest = async () => {
  const apiResponse = await triggerGet('/business/products/');
  const responseData = await apiResponse.json();
  if (responseData.report.status === 200) {
    return handleSuccess(responseData);
  }
  return handleError(responseData);
};

// Return all sections on single Product
const getAllSectionsApiRequest = async id => {
  const apiResponse = await triggerGet("/business/products/".concat(id, "/sections/"));
  const responseData = await apiResponse.json();
  if (responseData.report.status === 200) {
    return handleSuccess(responseData);
  }
  return handleError(responseData);
};

// Return all videos on single Section
const getAllVideosApiRequest = async id => {
  const apiResponse = await triggerGet("/business/sections/".concat(id, "/files/"));
  const responseData = await apiResponse.json();
  if (responseData.report.status === 200) {
    return handleSuccess(responseData);
  }
  return handleError(responseData);
};

// Return all videos on single Product
const getVideosByProductIdApiRequest = async id => {
  const apiResponse = await triggerGet("/business/products/".concat(id, "/files/"));
  const responseData = await apiResponse.json();
  if (responseData.report.status === 404) {
    return {
      success: true,
      data: {},
      report: {},
      result: false
    };
  }
  if (responseData.report.status === 200) {
    const result = responseData.data.findIndex(x => x.files_intro === 'Y' || x.files_free === 'Y') >= 0;
    return {
      success: true,
      data: {},
      report: {},
      result: result
    };
  } else {
    return handleError(responseData);
  }
};

// Create a product
const createProductApiRequest = async data => {
  const apiResponse = await triggerPost('/business/products', data);
  const responseData = await apiResponse.json();
  if ([200, 201].includes(responseData.report.status)) {
    return handleSuccess(responseData, true);
  }
  return handleError(responseData);
};

// Update Product Activity
const changeProductActivityApiRequest = async id => {
  const apiResponse = await triggerGet("/business/products/status/".concat(id, "/"));
  const responseData = await apiResponse.json();
  if (responseData.report.status === 200) {
    return handleSuccess(responseData);
  }
  return handleError(responseData);
};

// Create a product section
const createProductSectionApiRequest = async (id, data) => {
  const apiResponse = await triggerPost("/business/products/".concat(id, "/sections"), data, 'text/plain');
  const responseData = await apiResponse.json();
  if ([200, 201].includes(responseData.report.status)) {
    return handleSuccess(responseData);
  }
  return handleError(responseData);
};

// Create a video for the product
const createProductVideoApiRequest = async (id, data) => {
  const apiResponse = await triggerPost("/business/products/".concat(id, "/files/"), data);
  const responseData = await apiResponse.json();
  if ([200, 201].includes(responseData.report.status)) {
    return handleSuccess(responseData, true);
  }
  return handleError(responseData);
};

// Get a product
const getProductApiRequest = async id => {
  const apiResponse = await triggerGet("/business/products/".concat(id, "/files/"));
  const responseData = await apiResponse.json();
  if (responseData.report.status === 200) {
    return handleSuccess(responseData, true);
  }
  return handleError(responseData);
};

// Delete a product
const archiveProductApiRequest = async (id, changeStatus) => {
  const apiResponse = await triggerGet("/business/products/archive/".concat(id, "/"));
  if (apiResponse.status === 200) {
    if (changeStatus) {
      return changeProductActivityApiRequest(id);
    } else {
      return {
        success: true,
        data: {},
        report: {}
      };
    }
  }
  return {
    success: false
  };
};

// Delete a section
const deleteSectionApiRequest = async (productId, sectionId) => {
  const apiResponse = await triggerDelete("/business/products/".concat(productId, "/sections/").concat(sectionId, "/"));
  if (apiResponse.status === 204) {
    return {
      success: true,
      data: {},
      report: {}
    };
  }
  return {
    success: false
  };
};

// Delete a Video
const deleteVideoApiRequest = async (productId, fileId, sectionIndex) => {
  const apiResponse = await triggerDelete("/business/products/".concat(productId, "/files/").concat(fileId, "/"));
  if (apiResponse.status === 204) {
    return {
      success: true,
      data: {
        sectionIndex
      },
      report: {}
    };
  }
  return {
    success: false
  };
};

// Edit a product
const editProductApiRequest = async (data, id) => {
  const apiResponse = await triggerPut("/business/products/".concat(id), data);
  const responseData = await apiResponse.json();
  if (responseData.report.status === 200) {
    return handleSuccess(responseData);
  }
  return handleError(responseData);
};

// Edit a section
const editSectionApiRequest = async (data, productId, sectionId) => {
  const apiResponse = await triggerPut("/business/products/".concat(productId, "/sections/").concat(sectionId, "/"), data);
  const responseData = await apiResponse.json();
  if (responseData.report.status === 200) {
    return handleSuccess(responseData);
  }
  return handleError(responseData);
};

// Edit a video
const editVideoApiRequest = async (productId, fileId, data) => {
  const apiResponse = await triggerPut("/business/products/".concat(productId, "/files/").concat(fileId, "/"), data);
  const responseData = await apiResponse.json();
  if (responseData.report.status === 200) {
    return handleSuccess(responseData);
  }
  return handleError(responseData);
};

//Get presigned S3 URL
const getProductPresignedS3Url = async id => {
  const apiResponse = await triggerPost("/business/products/".concat(id, "/files/url"));
  const responseData = await apiResponse.json();
  if ([200, 201].includes(responseData.report.status)) {
    return handleSuccess(responseData);
  }
  return handleError(responseData);
};

// Update a product
const updateProductApiRequest = async data => {
  const apiResponse = await triggerPut('/business/products/', data);
  const responseData = await apiResponse.json();
  if ([200, 201].includes(responseData.report.status)) {
    return handleSuccess(responseData);
  }
  return handleError(responseData);
};

// upload on S3
const uploadFileToS3 = async (files, presignedUrl, onProgressCallback) => {
  // console.log('files', files);
  try {
    await uploadS3WithProgress(presignedUrl, files, onProgressCallback);
    return {
      success: true,
      data: {},
      report: {}
    };
  } catch (_unused) {
    return {
      success: false
    };
  }
};

// Upload multiple files to S3 with aggregated overall progress
const uploadMultipleFilesToS3 = async (fileUrlPairs, onOverallProgressCallback) => {
  try {
    const fileCount = fileUrlPairs.length;
    if (fileCount === 0) {
      return {
        success: true,
        data: {},
        report: {}
      };
    }
    const progressMap = {};
    const uploadPromises = fileUrlPairs.map((_ref, index) => {
      let {
        file,
        url
      } = _ref;
      progressMap[index] = 0;
      return uploadS3WithProgress(url, file, percentComplete => {
        progressMap[index] = percentComplete;
        if (onOverallProgressCallback) {
          const totalProgress = Object.values(progressMap).reduce((sum, p) => sum + p, 0) / fileCount;
          onOverallProgressCallback(totalProgress);
        }
      });
    });
    await Promise.all(uploadPromises);
    if (onOverallProgressCallback) {
      onOverallProgressCallback(100);
    }
    return {
      success: true,
      data: {},
      report: {}
    };
  } catch (_unused2) {
    return {
      success: false
    };
  }
};
export const uploadS3WithProgress = (url, file, progressCallback) => {
  return new Promise((resolve, reject) => {
    const xhr = new XMLHttpRequest();
    xhr.onreadystatechange = () => {
      if (xhr.readyState === 4) {
        if (xhr.status === 200) {
          resolve(xhr);
        } else {
          reject(xhr);
        }
      }
    };
    if (progressCallback) {
      xhr.upload.onprogress = e => {
        if (e.lengthComputable) {
          const percentComplete = e.loaded / file.size * 100;
          progressCallback(percentComplete);
        }
      };
    }
    xhr.open('PUT', url);
    xhr.send(file);
  });
};

// Preview File
const previewFileApiRequest = async function (productId, fileId) {
  let isPublic = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  const apiResponse = await triggerGet(isPublic ? "/public/products/".concat(productId, "/files/").concat(fileId, "/access/") : "/business/products/".concat(productId, "/files/").concat(fileId, "/access/"), !isPublic);
  const responseData = await apiResponse.json();
  if (responseData.report.status === 200) {
    return handleSuccess(responseData);
  }
  return handleError(responseData);
};

// Get all archived products
const getAllArchivedProductsApiRequest = async () => {
  const apiResponse = await triggerGet('/business/products/archive');
  const responseData = await apiResponse.json();
  if (responseData.report.status === 200) {
    return handleSuccess(responseData);
  }
  return handleError(responseData);
};

// Return product from archive
const restoreProductApiRequest = async id => {
  const apiResponse = await triggerGet("/business/products/archive/".concat(id, "/"));
  if (apiResponse.status === 200) {
    return {
      success: true,
      data: {},
      report: {}
    };
  }
  return {
    success: false
  };
};
export { createGroupApiRequest, editProductGroupApiRequest, deleteProductGroupApiRequest, restoreProductApiRequest, getGroupsForProductsApiRequest, getAllProductsApiRequest, getAllSectionsApiRequest, getAllVideosApiRequest, createProductApiRequest, archiveProductApiRequest, deleteSectionApiRequest, deleteVideoApiRequest, createProductSectionApiRequest, createProductVideoApiRequest, getProductApiRequest, updateProductApiRequest, editSectionApiRequest, editProductApiRequest, editVideoApiRequest, getProductPresignedS3Url, uploadFileToS3, uploadMultipleFilesToS3, changeProductActivityApiRequest, previewFileApiRequest, getAllArchivedProductsApiRequest, getVideosByProductIdApiRequest };